// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2sj8g","buttons":"Footer_buttons__3ufEL"};